import { render, staticRenderFns } from "./fss7Relevance.vue?vue&type=template&id=0d6b059e"
import script from "./fss7Relevance.vue?vue&type=script&lang=js"
export * from "./fss7Relevance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports